export const FOREX_BUY_MODULE_NAME: string = 'buy';

export enum ForexBuyGetter {
	preventNextRoute = 'preventNextRoute',
	currentDraft = 'currentDraft',
}

export enum ForexBuyMutation {
	setCurrentDraft = 'setCurrentDraft',
	updateCurrentDraft = 'updateCurrentDraft',
	resetCurrentDraft = 'resetCurrentDraft',
	setPreventNextRoute = 'setPreventNextRoute',
	setOperationType = 'setOperationType',
	setDraftIsSent = 'setDraftIsSent',
}

export enum ForexBuyAction {
	uploadFile = 'uploadFile',
	deleteFile = 'deleteFile',
	createDraft = 'createDraft',
	deleteDraft = 'deleteDraft',
	updateDraft = 'updateDraft',
	createOrUpdateDraft = 'createOrUpdateDraft',
	sendDraftToAccountant = 'sendDraftToAccountant',
	sendDraftToDirector = 'sendDraftToDirector',
	canSendDraftToDirector = 'canSendDraftToDirector',
}